export default __webpack_public_path__ + "static/media/10.eacba4a2.jpg";